import React, { useState, useEffect, useCallback } from 'react';

const inp = { width: '100%', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', boxSizing: 'border-box', background: '#fff', height: 26 };
const lbl = { fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 };

function token() { return localStorage.getItem('token'); }
function isAdmin() { return localStorage.getItem('nomeUsuario') === 'Vagner Freitas'; }

// Dados do próprio usuário, direto do token (base64url → normaliza antes do atob)
function usuarioDoToken() {
  try {
    const p = JSON.parse(atob((token() || '').split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return { id: p.id || '', nome: p.nome || '', email: p.email || '' };
  } catch { return { id: '', nome: '', email: '' }; }
}

const CARGOS = ['Administrador Geral', 'Closer', 'SDR', 'Operacional'];

function WhatsAppUsuario({ userId, nome }) {
  const [wa, setWa] = React.useState({ status: 'desconectado', qr: null });
  const [carregando, setCarregando] = React.useState(false);

  React.useEffect(() => {
    function checar() {
      fetch(`/whatsapp/usuario/${userId}/status`, { headers: { Authorization: `Bearer ${token()}` } })
        .then(r => r.json()).then(setWa).catch(() => {});
    }
    checar();
    const t = setInterval(checar, 5000);
    return () => clearInterval(t);
  }, [userId]);

  async function conectar() {
    setCarregando(true);
    await fetch(`/whatsapp/usuario/${userId}/iniciar`, { method: 'POST', headers: { Authorization: `Bearer ${token()}` } });
    setTimeout(() => setCarregando(false), 2000);
  }

  async function desconectar() {
    setCarregando(true);
    await fetch(`/whatsapp/usuario/${userId}/desconectar`, { method: 'POST', headers: { Authorization: `Bearer ${token()}` } });
    setTimeout(() => setCarregando(false), 2000);
  }

  const cor = wa.status === 'conectado' ? '#16a34a' : wa.status === 'aguardando_qr' ? '#d97706' : wa.status === 'conflito' ? '#dc2626' : '#6b7280';
  const label = wa.status === 'conectado' ? 'WhatsApp conectado'
    : wa.status === 'aguardando_qr' ? 'Aguardando QR Code'
    : wa.status === 'conflito' ? 'Conflito — o mesmo WhatsApp está aberto em outro lugar. Feche lá e clique em Conectar.'
    : 'WhatsApp desconectado';

  return (
    <div style={{ marginTop: 8, padding: '8px 10px', background: '#f9fafb', borderRadius: 3, border: '1px solid #e8eaed' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 6 }}>
        <span style={{ fontSize: 12, fontWeight: 600, color: cor }}>{label}</span>
        <div style={{ display: 'flex', gap: 4 }}>
          {(wa.status === 'desconectado' || wa.status === 'conflito') && (
            <button onClick={conectar} disabled={carregando}
              style={{ background: '#0a1628', color: '#fff', padding: '2px 10px', fontSize: 11, borderRadius: 4, border: 'none', cursor: 'pointer', fontWeight: 600 }}>
              {carregando ? '...' : 'Conectar'}
            </button>
          )}
          {wa.status === 'aguardando_qr' && (
            <button onClick={desconectar} disabled={carregando}
              style={{ background: '#f3f4f6', color: '#374151', padding: '2px 10px', fontSize: 11, borderRadius: 4, border: '1px solid #d1d5db', cursor: 'pointer' }}>
              Cancelar
            </button>
          )}
          {wa.status === 'conectado' && (
            <button onClick={desconectar} disabled={carregando}
              style={{ background: '#fef2f2', color: '#dc2626', padding: '2px 10px', fontSize: 11, borderRadius: 4, border: '1px solid #fecaca', cursor: 'pointer' }}>
              {carregando ? '...' : 'Desconectar'}
            </button>
          )}
        </div>
      </div>

      {wa.status === 'aguardando_qr' && wa.qr && (
        <div style={{ marginTop: 10, textAlign: 'center' }}>
          <p style={{ fontSize: 12, color: '#374151', marginBottom: 6 }}>
            Abra o WhatsApp de <strong>{nome}</strong> → <strong>Dispositivos conectados</strong> → escaneie:
          </p>
          <img src={wa.qr} alt="QR Code" style={{ width: 160, height: 160, border: '2px solid #0a1628', borderRadius: 4 }} />
        </div>
      )}
    </div>
  );
}

function StatusWhatsApp() {
  const [wa, setWa] = React.useState({ status: '...', qr: null });
  const [reconectando, setReconectando] = React.useState(false);
  const [desconectando, setDesconectando] = React.useState(false);

  React.useEffect(() => {
    function checar() {
      fetch('/whatsapp/status', { headers: { Authorization: `Bearer ${token()}` } })
        .then(r => r.json()).then(setWa).catch(() => {});
    }
    checar();
    const t = setInterval(checar, 5000);
    return () => clearInterval(t);
  }, []);

  async function reconectar() {
    setReconectando(true);
    await fetch('/whatsapp/reconectar', { method: 'POST', headers: { Authorization: `Bearer ${token()}` } });
    setTimeout(() => setReconectando(false), 3000);
  }

  async function desconectar() {
    setDesconectando(true);
    await fetch('/whatsapp/desconectar', { method: 'POST', headers: { Authorization: `Bearer ${token()}` } });
    setTimeout(() => setDesconectando(false), 2000);
  }

  const cor = wa.status === 'conectado' ? '#16a34a' : wa.status === 'aguardando_qr' ? '#d97706' : '#dc2626';
  const label = wa.status === 'conectado' ? 'Conectado' : wa.status === 'aguardando_qr' ? 'Aguardando QR Code' : 'Desconectado';

  return (
    <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', overflow: 'hidden', marginBottom: 14 }}>
      <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        WhatsApp
      </div>
      <div style={{ padding: '10px 14px' }}>
        <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>Conecte o WhatsApp da empresa para receber notificações automáticas quando uma nova oportunidade for criada.</p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: wa.status === 'aguardando_qr' && wa.qr ? 10 : 0 }}>
          <span style={{ fontWeight: 700, fontSize: 13, color: cor }}>{label}</span>
          {wa.status === 'conectado' && (
            <button onClick={desconectar} disabled={desconectando}
              style={{ background: '#fef2f2', color: '#dc2626', padding: '3px 10px', borderRadius: 4, fontSize: 11, fontWeight: 600, border: '1px solid #fecaca', cursor: 'pointer' }}>
              {desconectando ? 'Aguarde...' : 'Desconectar'}
            </button>
          )}
          {wa.status === 'desconectado' && (
            <button onClick={reconectar} disabled={reconectando}
              style={{ background: '#f3f4f6', color: '#374151', padding: '3px 10px', borderRadius: 4, fontSize: 11, fontWeight: 600, border: '1px solid #d1d5db', cursor: 'pointer' }}>
              {reconectando ? 'Aguarde...' : 'Reconectar'}
            </button>
          )}
        </div>
        {wa.status === 'aguardando_qr' && wa.qr && (
          <div style={{ textAlign: 'center' }}>
            <p style={{ fontSize: 12, color: '#374151', marginBottom: 10 }}>
              Abra o WhatsApp da empresa → <strong>Dispositivos conectados</strong> → <strong>Conectar dispositivo</strong> → escaneie o QR Code abaixo:
            </p>
            <img src={wa.qr} alt="QR Code WhatsApp" style={{ width: 200, height: 200, border: '3px solid #0a1628', borderRadius: 4 }} />
          </div>
        )}
      </div>
    </div>
  );
}

// Visão restrita (closers liberados, ex.: Pedro): só conectar o PRÓPRIO
// WhatsApp — sem usuários, sem WhatsApp da empresa, sem credenciais INPI.
function ConfigWhatsAppProprio() {
  const eu = usuarioDoToken();
  return (
    <div style={{ maxWidth: 640 }}>
      <h1 style={{ fontSize: 18, fontWeight: 700, color: '#0a1628', marginBottom: 4 }}>⚙️ Configurações</h1>
      <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 14 }}>
        Conecte aqui o seu WhatsApp — é por ele que a Clau responde os seus leads e que saem os seus lembretes.
      </p>
      <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', padding: '12px 16px' }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 8 }}>WhatsApp de {eu.nome}</div>
        <WhatsAppUsuario userId={eu.id} nome={eu.nome} />
      </div>
    </div>
  );
}

export default function Configuracoes() {
  if (!isAdmin()) return <ConfigWhatsAppProprio />;
  return <ConfiguracoesAdmin />;
}

// 📣 Central de Avisos (12/09/2026): a conversa 1:1 com a Clau fica só pra
// diálogo; os avisos automáticos vão pro grupo Urgente (na hora) ou pro grupo
// Boletim (8h15 / 18h / sexta 17h30). "Modo antigo" devolve tudo ao 1:1.
function SecaoAvisos() {
  const [dados, setDados] = useState(null);
  const [cfg, setCfg] = useState(null);
  const [msg, setMsg] = useState('');
  const [ocupado, setOcupado] = useState('');
  const auth = { Authorization: `Bearer ${token()}` };

  const carregar = useCallback(() => {
    fetch('/avisos/config', { headers: auth })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) { setDados(d); setCfg(d.config); } })
      .catch(() => {});
  }, []);
  useEffect(() => { carregar(); }, [carregar]);

  async function salvar(e) {
    e.preventDefault();
    setOcupado('salvar'); setMsg('');
    const r = await fetch('/avisos/config', { method: 'PUT', headers: { 'Content-Type': 'application/json', ...auth }, body: JSON.stringify(cfg) })
      .then(x => x.json()).catch(() => ({ erro: 'Falha ao salvar' }));
    setMsg(r.erro ? `⚠ ${r.erro}` : '✅ Canais salvos.');
    setOcupado(''); carregar();
  }

  async function acao(rota, rotulo, okMsg) {
    setOcupado(rotulo); setMsg('');
    const r = await fetch(rota, { method: 'POST', headers: auth }).then(x => x.json()).catch(() => ({ erro: 'Falha' }));
    setMsg(r.erro ? `⚠ ${r.erro}` : okMsg(r));
    setOcupado(''); carregar();
  }

  if (!cfg) return null;
  const grupos = dados?.grupos || [];
  const fila = dados?.fila || {};
  const set = (k, v) => setCfg(c => ({ ...c, [k]: v }));
  const selGrupo = (k, rotulo, dica) => (
    <div>
      <label style={lbl}>{rotulo}</label>
      <select style={inp} value={cfg[k] || ''} onChange={e => set(k, e.target.value)}>
        <option value="">— sem grupo (cai no 1:1 com a Clau) —</option>
        {grupos.map(g => <option key={g.id} value={g.id}>{g.nome}</option>)}
        {cfg[k] && !grupos.some(g => g.id === cfg[k]) && <option value={cfg[k]}>{cfg[k]} (grupo não listado agora)</option>}
      </select>
      <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>{dica}</div>
    </div>
  );
  const hora = (k, rotulo) => (
    <div>
      <label style={lbl}>{rotulo}</label>
      <input style={inp} value={cfg[k] || ''} placeholder="HH:MM" maxLength={5} onChange={e => set(k, e.target.value)} />
    </div>
  );
  const btn = (extra) => ({ background: '#0a1628', color: '#fff', padding: '4px 12px', fontSize: 12, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer', ...extra });

  return (
    <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', overflow: 'hidden' }}>
      <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase' }}>
        📣 Central de Avisos
      </div>
      <div style={{ padding: '10px 14px' }}>
        <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>
          A conversa com a Clau fica só para diálogo. Os avisos automáticos do sistema vão para o grupo <b>Urgente</b> (na hora: prazo amanhã/hoje, lead quente, falha) ou para o grupo <b>Boletim</b> (resumos às 8h15, 18h15 e sexta 17h30, só em dia útil).
          Os grupos precisam ter o número da Clau como participante — a lista abaixo mostra os grupos em que ela está.
          {grupos.length === 0 && <span style={{ color: '#b45309' }}> Nenhum grupo listado: confira se o WhatsApp da empresa está conectado.</span>}
        </p>
        <form onSubmit={salvar} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            {selGrupo('urgente', 'Grupo Urgente (fura na hora)', 'Prazo amanhã/HOJE · lead PAP · lead de anúncio · lead da saudadora · falha do estagiário')}
            {selGrupo('boletim', 'Grupo Boletim (resumos)', '8h15: prazos em 7 dias, financeiro, briefing, assinaturas · 18h15: leads, resumo do dia, documentos, aquecimento, site · sexta: placar')}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
            {hora('hora_dia', 'Boletim do dia')}
            {hora('hora_movimento', 'Movimento do dia')}
            {hora('hora_semana', 'Boletim da semana (sexta)')}
          </div>
          <label style={{ fontSize: 12, color: '#374151', display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" style={{ width: 'auto', margin: 0 }} checked={!!cfg.modo_antigo} onChange={e => set('modo_antigo', e.target.checked)} />
            Modo antigo — tudo volta a chegar na hora, no 1:1 com a Clau (desliga grupos e boletins)
          </label>
          <div style={{ fontSize: 12, color: '#374151' }}>
            Na fila para o próximo boletim: <b>dia {fila.dia || 0}</b> · <b>movimento {fila.movimento || 0}</b> · <b>semana {fila.semana || 0}</b>
          </div>
          {msg && <div style={{ background: msg.startsWith('⚠') ? '#fef2f2' : '#f0fdf4', border: `1px solid ${msg.startsWith('⚠') ? '#fecaca' : '#bbf7d0'}`, color: msg.startsWith('⚠') ? '#dc2626' : '#166534', padding: '5px 8px', borderRadius: 4, fontSize: 12 }}>{msg}</div>}
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button type="submit" disabled={!!ocupado} style={btn()}>{ocupado === 'salvar' ? 'Salvando...' : 'Salvar canais'}</button>
            <button type="button" disabled={!!ocupado} style={btn({ background: '#374151' })}
              onClick={() => acao('/avisos/teste', 'teste', r => `✅ Teste enviado — Urgente: ${r.urgente ? 'ok' : 'falhou'} · Boletim: ${r.boletim ? 'ok' : 'falhou'}`)}>
              {ocupado === 'teste' ? 'Enviando...' : 'Testar canais'}
            </button>
            {['dia', 'movimento', 'semana'].map(t => (
              <button key={t} type="button" disabled={!!ocupado} style={btn({ background: '#fff', color: '#0a1628', border: '1px solid #0a1628' })}
                onClick={() => acao(`/avisos/boletim/${t}`, t, r => r.vazio ? `Boletim "${t}" sem itens na fila — nada enviado.` : `✅ Boletim "${t}" enviado (${r.itens} item(ns)).`)}>
                {ocupado === t ? 'Enviando...' : `Enviar boletim: ${t}`}
              </button>
            ))}
          </div>
        </form>
      </div>
    </div>
  );
}

// 🧾 NFS-e de Campina Grande direto no webservice da prefeitura (WebISS).
// O certificado A1 e a senha ficam NO SERVIDOR — cadastrados por aqui.
function SecaoNfse() {
  const [cfg, setCfg] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [msg, setMsg] = useState('');
  const [pfx, setPfx] = useState(null);
  const [senhaPfx, setSenhaPfx] = useState('');
  const [subindo, setSubindo] = useState(false);
  const [msgCert, setMsgCert] = useState('');
  const [testando, setTestando] = useState(false);
  const [resTeste, setResTeste] = useState(null);

  const carregar = useCallback(() => {
    fetch('/nfse/config', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.ok ? r.json() : null).then(setCfg).catch(() => {});
  }, []);
  useEffect(() => { carregar(); }, [carregar]);

  async function salvar(e) {
    e.preventDefault();
    setSalvando(true); setMsg('');
    const r = await fetch('/nfse/config', { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` }, body: JSON.stringify(cfg) })
      .then(x => x.json()).catch(() => ({ erro: 'Falha ao salvar' }));
    setMsg(r.erro ? `⚠ ${r.erro}` : '✅ Configuração salva.');
    setSalvando(false);
  }

  async function subirCert(e) {
    e.preventDefault();
    if (!pfx) return setMsgCert('⚠ Escolha o arquivo .pfx');
    setSubindo(true); setMsgCert('');
    const fd = new FormData();
    fd.append('pfx', pfx);
    fd.append('senha', senhaPfx);
    const r = await fetch('/nfse/certificado', { method: 'POST', headers: { Authorization: `Bearer ${token()}` }, body: fd })
      .then(x => x.json()).catch(() => ({ erro: 'Falha no envio' }));
    setMsgCert(r.erro ? `⚠ ${r.erro}` : `✅ Certificado de ${r.titular} válido até ${new Date(r.validade).toLocaleDateString('pt-BR')}.`);
    setSenhaPfx(''); setPfx(null);
    setSubindo(false);
    carregar();
  }

  async function emitirTeste() {
    setTestando(true); setResTeste(null);
    const r = await fetch('/nfse/emitir-teste', { method: 'POST', headers: { Authorization: `Bearer ${token()}` } })
      .then(x => x.json()).catch(() => ({ erro: 'Falha na chamada' }));
    setResTeste(r);
    setTestando(false);
  }

  if (!cfg) return null;
  const set = (k, v) => { setCfg(c => ({ ...c, [k]: v })); setMsg(''); };
  const campo = (k, rotulo, ph) => (
    <div><label style={lbl}>{rotulo}</label><input style={inp} value={cfg[k] ?? ''} onChange={e => set(k, e.target.value)} placeholder={ph || ''} /></div>
  );

  return (
    <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', overflow: 'hidden', marginBottom: 14 }}>
      <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        🧾 NFS-e — Campina Grande (WebISS)
      </div>
      <div style={{ padding: '10px 14px' }}>
        <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>
          Emissão direta no webservice da prefeitura, sem gateway. Preencha com os MESMOS dados das notas que você emite pelo portal.
          Ambiente <strong>homologação</strong> = nota de treino, sem valor fiscal.
        </p>

        <form onSubmit={salvar} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 8, marginBottom: 10 }}>
          <div>
            <label style={lbl}>Ambiente</label>
            <select style={inp} value={cfg.ambiente} onChange={e => set('ambiente', e.target.value)}>
              <option value="homologacao">🧪 Homologação (teste)</option>
              <option value="producao">🔴 Produção (vale fiscalmente)</option>
            </select>
          </div>
          {campo('cnpj', 'CNPJ do prestador', '00.000.000/0001-00')}
          {campo('inscricao_municipal', 'Inscrição Municipal (CMC)')}
          {campo('razao_social', 'Razão Social')}
          <div>
            <label style={lbl}>Simples Nacional?</label>
            <select style={inp} value={cfg.optante_simples} onChange={e => set('optante_simples', e.target.value)}>
              <option value="1">Sim (optante)</option>
              <option value="2">Não</option>
            </select>
          </div>
          {campo('item_lista_servico', 'Item lista de serviço (LC 116)', 'ex.: 17.20')}
          {campo('codigo_tributacao_municipio', 'Cód. tributação municipal')}
          {campo('cnae', 'CNAE')}
          {campo('aliquota', 'Alíquota ISS (%)', 'ex.: 3.00')}
          {campo('serie_rps', 'Série do RPS')}
          {campo('proximo_rps', 'Próximo nº de RPS')}
          <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <button type="submit" disabled={salvando} style={{ background: '#0a1628', color: '#fff', padding: '4px 16px', fontSize: 12, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer', height: 26 }}>
              {salvando ? 'Salvando…' : 'Salvar'}
            </button>
          </div>
        </form>
        {msg && <div style={{ fontSize: 12, color: msg.startsWith('⚠') ? '#dc2626' : '#166534', marginBottom: 8 }}>{msg}</div>}

        <div style={{ borderTop: '1px dashed #d1d5db', paddingTop: 10, marginBottom: 10 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', marginBottom: 4 }}>
            Certificado digital A1 {cfg.certificado?.ok
              ? <span style={{ color: '#15803d', fontWeight: 600 }}> · ✅ {cfg.certificado.titular} (válido até {new Date(cfg.certificado.validade).toLocaleDateString('pt-BR')})</span>
              : cfg.certificado ? <span style={{ color: '#dc2626', fontWeight: 600 }}> · ⚠ {cfg.certificado.erro}</span>
              : <span style={{ color: '#b45309', fontWeight: 600 }}> · ainda não cadastrado</span>}
          </div>
          <form onSubmit={subirCert} style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
            <input type="file" accept=".pfx,.p12" onChange={e => setPfx(e.target.files[0] || null)} style={{ fontSize: 12 }} />
            <input type="password" value={senhaPfx} onChange={e => setSenhaPfx(e.target.value)} placeholder="senha do certificado" style={{ ...inp, width: 180 }} />
            <button type="submit" disabled={subindo} style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', fontSize: 12, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer' }}>
              {subindo ? 'Validando…' : '📤 Enviar certificado'}
            </button>
          </form>
          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>A senha é validada abrindo o arquivo e fica guardada só no servidor.</div>
        </div>

        <div style={{ borderTop: '1px dashed #d1d5db', paddingTop: 10 }}>
          <button onClick={emitirTeste} disabled={testando || cfg.ambiente !== 'homologacao'}
            title={cfg.ambiente !== 'homologacao' ? 'Troque o ambiente pra homologação' : 'Emite uma nota de R$ 1,00 no ambiente de treino'}
            style={{ background: '#15803d', color: '#fff', padding: '5px 16px', fontSize: 12, fontWeight: 700, borderRadius: 4, border: 'none', cursor: 'pointer', opacity: cfg.ambiente !== 'homologacao' ? 0.5 : 1 }}>
            {testando ? 'Falando com a prefeitura…' : '🧪 Emitir nota de TESTE (homologação)'}
          </button>
          {resTeste && (
            <div style={{ marginTop: 8, fontSize: 12, background: resTeste.sucesso ? '#f0fdf4' : '#fef2f2', border: `1px solid ${resTeste.sucesso ? '#bbf7d0' : '#fecaca'}`, borderRadius: 4, padding: '6px 10px' }}>
              {resTeste.sucesso
                ? <span style={{ color: '#166534' }}>🎉 NFS-e nº <strong>{resTeste.numero_nfse}</strong> · verificação {resTeste.codigo_verificacao} (RPS {resTeste.rps_numero})</span>
                : <span style={{ color: '#b91c1c' }}>{resTeste.erro || (resTeste.erros || []).join(' · ') || 'A prefeitura recusou — resposta sem código de verificação.'}</span>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function ConfiguracoesAdmin() {
  const [form, setForm] = useState({ inpi_login: '', inpi_senha: '' });
  const [salvando, setSalvando] = useState(false);
  const [msg, setMsg] = useState('');
  const [erro, setErro] = useState('');
  const [usuarios, setUsuarios] = useState([]);
  const [editandoId, setEditandoId] = useState(null);
  const [editForm, setEditForm] = useState({ nome: '', email: '', cargo: '', nova_senha: '' });
  const [salvandoUser, setSalvandoUser] = useState(false);
  const [msgUser, setMsgUser] = useState('');
  const [modalNovo, setModalNovo] = useState(false);
  const [novoForm, setNovoForm] = useState({ nome: '', email: '', cargo: '', senha: '' });
  const [salvandoNovo, setSalvandoNovo] = useState(false);
  const [erroNovo, setErroNovo] = useState('');
  const [msgNovo, setMsgNovo] = useState('');
  const [erroUser, setErroUser] = useState('');
  const [confirmarExc, setConfirmarExc] = useState(null);

  useEffect(() => {
    fetch('/config', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json())
      .then(d => setForm({ inpi_login: d.inpi_login || '', inpi_senha: d.inpi_senha || '' }))
      .catch(() => {});
  }, []);

  const carregarUsuarios = useCallback(() => {
    fetch('/usuarios', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(setUsuarios).catch(() => {});
  }, []);

  useEffect(() => { carregarUsuarios(); }, [carregarUsuarios]);

  async function salvar(e) {
    e.preventDefault();
    setMsg(''); setErro('');
    setSalvando(true);
    try {
      const res = await fetch('/config', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` }, body: JSON.stringify(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.erro);
      setMsg('Configurações salvas com sucesso!');
    } catch (e) { setErro(e.message); }
    finally { setSalvando(false); }
  }

  function abrirEditar(u) {
    setEditandoId(u._id);
    setEditForm({ nome: u.nome, email: u.email, cargo: u.cargo || '', telefone: u.telefone || '', telefone_pessoal: u.telefone_pessoal || '', comissao_pct: u.comissao_pct ?? '', nova_senha: '' });
    setMsgUser(''); setErroUser('');
  }

  async function salvarUsuario(e) {
    e.preventDefault();
    setMsgUser(''); setErroUser('');
    setSalvandoUser(true);
    try {
      const res = await fetch(`/usuarios/${editandoId}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify(editForm),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.erro);
      setMsgUser('Usuário atualizado com sucesso!');
      setEditandoId(null);
      carregarUsuarios();
    } catch (e) { setErroUser(e.message); }
    finally { setSalvandoUser(false); }
  }

  async function criarUsuario(e) {
    e.preventDefault();
    setErroNovo(''); setMsgNovo('');
    if (!novoForm.senha) return setErroNovo('Senha é obrigatória');
    setSalvandoNovo(true);
    try {
      const res = await fetch('/auth/register', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify({ nome: novoForm.nome, email: novoForm.email, senha: novoForm.senha }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.erro || 'Erro ao criar usuário');
      if (novoForm.cargo && data.id) {
        await fetch(`/usuarios/${data.id}`, {
          method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
          body: JSON.stringify({ nome: novoForm.nome, email: novoForm.email, cargo: novoForm.cargo }),
        });
      }
      setMsgNovo('Usuário criado com sucesso!');
      setNovoForm({ nome: '', email: '', cargo: '', senha: '' });
      carregarUsuarios();
      setTimeout(() => { setModalNovo(false); setMsgNovo(''); }, 1500);
    } catch (e) { setErroNovo(e.message); }
    finally { setSalvandoNovo(false); }
  }

  async function excluirUsuario() {
    await fetch(`/usuarios/${confirmarExc}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token()}` } });
    setConfirmarExc(null);
    carregarUsuarios();
  }

  return (
    <div style={{ maxWidth: 700 }}>
      <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', marginBottom: 14 }}>Configurações</h1>

      {/* Funcionários */}
      <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', overflow: 'hidden', marginBottom: 14 }}>
        <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Funcionários</span>
          {isAdmin() && (
            <button onClick={() => { setModalNovo(true); setErroNovo(''); setMsgNovo(''); setNovoForm({ nome: '', email: '', cargo: '', senha: '' }); }}
              style={{ background: '#0a1628', color: '#fff', padding: '2px 10px', borderRadius: 4, fontWeight: 600, fontSize: 11, border: 'none', cursor: 'pointer' }}>
              + Novo Funcionário
            </button>
          )}
        </div>
        <div style={{ padding: '10px 14px' }}>
          <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>Edite nome, email, função e senha de cada usuário do sistema.</p>

          {modalNovo && (
            <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
              <div style={{ background: '#fff', borderRadius: 4, width: '100%', maxWidth: 400, border: '1px solid #c8d0da' }}>
                <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '4px 4px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: '#fff', fontSize: 13, fontWeight: 700 }}>Novo Funcionário</span>
                  <button onClick={() => setModalNovo(false)} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 18, lineHeight: 1 }}>×</button>
                </div>
                <form onSubmit={criarUsuario} style={{ padding: '10px 14px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                  <div><label style={lbl}>Nome *</label><input style={inp} value={novoForm.nome} onChange={e => setNovoForm(f => ({ ...f, nome: e.target.value }))} required placeholder="Nome completo" /></div>
                  <div><label style={lbl}>Email *</label><input style={inp} type="email" value={novoForm.email} onChange={e => setNovoForm(f => ({ ...f, email: e.target.value }))} required placeholder="email@exemplo.com" /></div>
                  <div>
                    <label style={lbl}>Função / Cargo</label>
                    <select style={inp} value={novoForm.cargo} onChange={e => setNovoForm(f => ({ ...f, cargo: e.target.value }))}>
                      <option value="">Sem cargo</option>
                      {CARGOS.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                  <div><label style={lbl}>Senha *</label><input style={inp} type="password" value={novoForm.senha} onChange={e => setNovoForm(f => ({ ...f, senha: e.target.value }))} required placeholder="••••••••" /></div>

                  {msgNovo && <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '5px 8px', borderRadius: 4, fontSize: 12 }}>{msgNovo}</div>}
                  {erroNovo && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', padding: '5px 8px', borderRadius: 4, fontSize: 12 }}>{erroNovo}</div>}

                  <div style={{ display: 'flex', gap: 8, paddingTop: 4, borderTop: '1px solid #e8eaed', marginTop: 2 }}>
                    <button type="submit" disabled={salvandoNovo} style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', fontWeight: 600, fontSize: 12, flex: 1, borderRadius: 4, border: 'none', cursor: 'pointer' }}>
                      {salvandoNovo ? 'Criando...' : 'Criar Funcionário'}
                    </button>
                    <button type="button" onClick={() => setModalNovo(false)} style={{ background: '#f3f4f6', color: '#374151', padding: '4px 12px', fontSize: 12, border: '1px solid #d1d5db', borderRadius: 4, cursor: 'pointer' }}>Cancelar</button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {confirmarExc && (
            <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
              <div style={{ background: '#fff', borderRadius: 4, padding: 20, maxWidth: 320, textAlign: 'center', border: '1px solid #c8d0da' }}>
                <p style={{ fontSize: 13, marginBottom: 14 }}>Tem certeza que deseja excluir este usuário?</p>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                  <button onClick={excluirUsuario} style={{ background: '#dc2626', color: '#fff', padding: '4px 14px', borderRadius: 4, fontWeight: 600, fontSize: 12, border: 'none', cursor: 'pointer' }}>Excluir</button>
                  <button onClick={() => setConfirmarExc(null)} style={{ background: '#f3f4f6', color: '#374151', padding: '4px 12px', borderRadius: 4, fontSize: 12, border: '1px solid #d1d5db', cursor: 'pointer' }}>Cancelar</button>
                </div>
              </div>
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {usuarios.map(u => (
              <div key={u._id} style={{ border: '1px solid #e8eaed', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: editandoId === u._id ? '#f0f4ff' : '#fafafa' }}>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 13, color: '#0a1628' }}>{u.nome}</div>
                    <div style={{ fontSize: 11, color: '#6b7280', marginTop: 1 }}>
                      {u.email}
                      {u.cargo && <span style={{ marginLeft: 8, background: '#e5e7eb', padding: '1px 6px', borderRadius: 10, fontSize: 10, fontWeight: 600 }}>{u.cargo}</span>}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    {editandoId === u._id ? (
                      <button onClick={() => setEditandoId(null)} style={{ background: '#f3f4f6', color: '#374151', padding: '2px 10px', fontSize: 11, borderRadius: 4, border: '1px solid #d1d5db', cursor: 'pointer' }}>Cancelar</button>
                    ) : (
                      <>
                        <button onClick={() => abrirEditar(u)} style={{ background: '#0a1628', color: '#fff', padding: '2px 10px', fontSize: 11, borderRadius: 4, fontWeight: 600, border: 'none', cursor: 'pointer' }}>Editar</button>
                        {isAdmin() && u.nome !== 'Vagner Freitas' && (
                          <button onClick={() => setConfirmarExc(u._id)} style={{ background: '#fef2f2', color: '#dc2626', padding: '2px 8px', fontSize: 11, borderRadius: 4, border: '1px solid #fecaca', cursor: 'pointer' }}>Excluir</button>
                        )}
                      </>
                    )}
                  </div>
                </div>

                <div style={{ padding: '0 12px 8px' }}>
                  <WhatsAppUsuario userId={u._id} nome={u.nome} />
                </div>

                {editandoId === u._id && (
                  <form onSubmit={salvarUsuario} style={{ padding: '10px 12px 12px', borderTop: '1px solid #e8eaed', background: '#fff' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                      <div><label style={lbl}>Nome *</label><input style={inp} value={editForm.nome} onChange={e => setEditForm(f => ({ ...f, nome: e.target.value }))} required /></div>
                      <div><label style={lbl}>Email *</label><input style={inp} type="email" value={editForm.email} onChange={e => setEditForm(f => ({ ...f, email: e.target.value }))} required /></div>
                      <div>
                        <label style={lbl}>Função / Cargo</label>
                        <select style={inp} value={editForm.cargo} onChange={e => setEditForm(f => ({ ...f, cargo: e.target.value }))}>
                          <option value="">Sem cargo</option>
                          {CARGOS.map(c => <option key={c} value={c}>{c}</option>)}
                        </select>
                      </div>
                      <div><label style={lbl}>Nova Senha <span style={{ fontWeight: 400, color: '#9ca3af', fontSize: 11 }}>(deixe em branco para manter)</span></label><input style={inp} type="password" value={editForm.nova_senha} onChange={e => setEditForm(f => ({ ...f, nova_senha: e.target.value }))} placeholder="••••••••" /></div>
                      <div><label style={lbl}>WhatsApp <span style={{ fontWeight: 400, color: '#9ca3af', fontSize: 11 }}>(lembretes do Closer)</span></label><input style={inp} value={editForm.telefone || ''} onChange={e => setEditForm(f => ({ ...f, telefone: e.target.value }))} placeholder="83999999999" /></div>
                      <div><label style={lbl}>WhatsApp pessoal <span style={{ fontWeight: 400, color: '#9ca3af', fontSize: 11 }}>(2º número — recebe os comunicados gerais)</span></label><input style={inp} value={editForm.telefone_pessoal || ''} onChange={e => setEditForm(f => ({ ...f, telefone_pessoal: e.target.value }))} placeholder="83999999999" /></div>
                      <div><label style={lbl}>% de comissão <span style={{ fontWeight: 400, color: '#9ca3af', fontSize: 11 }}>(sobre o que o cliente PAGAR no mês — relatório de Comissões)</span></label><input style={inp} value={editForm.comissao_pct ?? ''} onChange={e => setEditForm(f => ({ ...f, comissao_pct: e.target.value }))} placeholder="ex.: 10" inputMode="decimal" /></div>
                    </div>

                    {msgUser && <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '5px 8px', borderRadius: 4, fontSize: 12, marginBottom: 8 }}>{msgUser}</div>}
                    {erroUser && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', padding: '5px 8px', borderRadius: 4, fontSize: 12, marginBottom: 8 }}>{erroUser}</div>}

                    <div style={{ display: 'flex', gap: 8 }}>
                      <button type="submit" disabled={salvandoUser} style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', fontWeight: 600, fontSize: 12, borderRadius: 4, border: 'none', cursor: 'pointer' }}>
                        {salvandoUser ? 'Salvando...' : 'Salvar alterações'}
                      </button>
                      <button type="button" onClick={() => setEditandoId(null)} style={{ background: '#f3f4f6', color: '#374151', padding: '4px 12px', fontSize: 12, border: '1px solid #d1d5db', borderRadius: 4, cursor: 'pointer' }}>Cancelar</button>
                    </div>
                  </form>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <StatusWhatsApp />

      <SecaoAvisos />

      <SecaoNfse />

      {/* Credenciais INPI */}
      <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', overflow: 'hidden' }}>
        <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          Credenciais INPI
        </div>
        <div style={{ padding: '10px 14px' }}>
          <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>
            Informe seu login e senha do sistema pePI do INPI para consultar processos automaticamente.
          </p>
          <form onSubmit={salvar} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div><label style={lbl}>Login do INPI (pePI)</label><input style={inp} value={form.inpi_login} onChange={e => setForm(f => ({ ...f, inpi_login: e.target.value }))} placeholder="Seu usuário no pePI" /></div>
            <div><label style={lbl}>Senha do INPI (pePI)</label><input style={inp} type="password" value={form.inpi_senha} onChange={e => setForm(f => ({ ...f, inpi_senha: e.target.value }))} placeholder="Sua senha no pePI" /></div>
            {msg && <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', padding: '5px 8px', borderRadius: 4, fontSize: 12 }}>{msg}</div>}
            {erro && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', padding: '5px 8px', borderRadius: 4, fontSize: 12 }}>{erro}</div>}
            <button type="submit" disabled={salvando} style={{ background: '#0a1628', color: '#fff', padding: '4px 16px', fontSize: 12, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer', alignSelf: 'flex-start' }}>
              {salvando ? 'Salvando...' : 'Salvar configurações'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
